
import { defineComponent } from 'vue'

export default defineComponent({
  props: {
    chainId: {
      type: Number,
      required: true
    }
  }
})
